/**
 * 产品类型
*/
const productItem = ['MINI电商小件', '精准零担', 'MINI电商大件', '定时达', '安心达', '普惠达'];

/**
 * 数据统计 请求条件
*/
export const TotalQuery = name => {
  return [
    [
      {
        // title: '总干线发出合计-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'scanSite', value: name},
        ]
      },
      {
        // title: '中转发出-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'isOriginCenter', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '网点出发-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'isOriginCenter', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省内件-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '省内件'},
          {key: 'scanType', value: '分拨装车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省外-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '非省内件'},
          {key: 'scanType', value: '分拨装车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
    [
      {
        // title: '总干线发出合计-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ]
      },
      {
        // title: '中转发出-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '网点出发-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省内件-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '省内件'},
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省外-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '非省内件'},
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
    [
      {
        // title: '总干线发出合计-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ]
      },
      {
        // title: '中转发出-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '网点出发-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省内件-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '省内件'},
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '省外-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'areaType', value: '非省内件'},
          {key: 'scanType', value: '分拨发车'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
  ]
}

/**
 * 产品类型 请求条件
*/
export const MustQuery = name => {
  return [
    [
      {
        // title: '优势产品-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'superiorityProduct', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '非优势产品-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'superiorityProduct', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '必走货-实际',
        dataSource: 'actual_load_unload_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨装车'},
          {key: 'mustGoGoods', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
    [
      {
        // title: '优势产品-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'superiorityProduct', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '非优势产品-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'superiorityProduct', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '必走货-预计',
        dataSource: 'route_plan_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'mustGoGoods', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
    [
      {
        // title: '优势产品-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'superiorityProduct', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      }, 
      {
        // title: '非优势产品-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'superiorityProduct', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '必走货-预报',
        dataSource: 'actual_forecast_result',
        dimensions: ['scanSite'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'mustGoGoods', value: '是'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
    ],
  ]
}

/**
 * 产品类型 请求条件
*/
export const ProductQuery = name => {
  const plan = [];
  const unload = [];
  const forecast = [];
  productItem.forEach(item => {
    unload.push({
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      andFilters: [
        {key: 'productType', value: item},
        {key: 'scanType', value: '分拨装车'},
        {key: 'scanSite', value: name},
      ]
    })
    plan.push({
      dataSource: 'route_plan_result',
      dimensions: ['scanSite'],
      andFilters: [
        {key: 'productType', value: item},
        {key: 'scanType', value: '分拨发车'},
        {key: 'scanSite', value: name},
      ]
    })
    forecast.push({
      dataSource: 'route_plan_result',
      dimensions: ['scanSite'],
      andFilters: [
        {key: 'productType', value: item},
        {key: 'scanType', value: '分拨发车'},
        {key: 'scanSite', value: name},
      ]
    })
  })
  return [unload, plan, forecast];
}

